import React, { useReducer, createContext, useContext } from "react";

export interface ITheme {
    [k: string]: string;
}
type Action = { type: string; payload: any };
type Dispatch = (action: Action) => void;
type State = { theme: ITheme };
type ThemeProviderProps = { children: React.ReactNode, theme: ITheme };

const ThemeContext =
    createContext<{ state: State; dispatch: Dispatch } | undefined>(undefined);

const themeReducer = (state: State, action: Action) => {
    switch (action.type) {
        case "set": {
            return action.payload;
        }
        default: {
            return state;
        }
    }
};

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
    const [state, dispatch] = useReducer(themeReducer, { theme });
    const value = { state, dispatch };

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
};

const useTheme = () => {
    const context = useContext(ThemeContext);

    if (context === undefined) {
        throw new Error("useTheme must be used within a ThemeProvider");
    }

    return context;
};

// toast actions
const setTheme = (theme: ITheme) => ({
    type: "set",
    payload: theme,
});

export { ThemeProvider, useTheme, setTheme };
